// extracted by mini-css-extract-plugin
module.exports = {"item":"jI","dark":"jJ","light":"jK","toggle":"jL"};